import PublicSearchPublishersStore from '@App/stores/search/public/public-search-publishers-store'
import { PaginationBody } from '@Entities/pagination'
import { searchPublishersForRH } from '@App/api/routes/search'
import { LegacyPublisherSearch, PublisherSearch } from '@App/stores/search/models/publisher-search'
import SearchCriteriaStore from '@App/stores/search/search-criteria-store'
import { SearchOptionType } from '@App/enum/search-option-type'
import { RequiredCriteria } from '@App/enum/required-criteria'
import { SelectOptionHide } from '@App/stores/search/models/select-option-hide'
import { v4 as uuidv4 } from 'uuid'
import { SearchCriterion } from '@App/stores/search/models/search-criterion'
import { SearchResultPartyDetails } from '@Entities/party-details'

import { PublisherModelWithWorksCount } from '@Entities/work/publisher-model-with-works-count'

export const targetSearchPublishersOptions: Array<SelectOptionHide<PublisherSearch>> = [
    {
        id: uuidv4(),
        value: 'fullName',
        label: 'Publisher Name',
    },
    { id: uuidv4(), value: 'ipiNameNumber', label: 'Publisher IPI' },
    { id: uuidv4(), value: 'hfaNumber', label: 'MLC Publisher Number' },
]

export const DEFAULT_TARGET_SEARCH_BY_PUBLISHER_CRITERIA: Array<SearchCriterion<PublisherSearch>> = [
    {
        id: targetSearchPublishersOptions[0].id,
        selectedOption: targetSearchPublishersOptions[0],
        searchTerm: '',
        isFixed: true,
    },
]

class TargetSearchPublishersStore extends PublicSearchPublishersStore {
    createPublisherSearchCriteriaStore(): SearchCriteriaStore<PublisherSearch> {
        const publisherSearchMaxCriteria = 1
        return new SearchCriteriaStore(
            DEFAULT_TARGET_SEARCH_BY_PUBLISHER_CRITERIA,
            targetSearchPublishersOptions,
            SearchOptionType.filter,
            RequiredCriteria.first,
            publisherSearchMaxCriteria
        )
    }

    protected async searchForPartiesApiCall(pagination: PaginationBody, query: PublisherSearch) {
        const results = await searchPublishersForRH(
            this.rootStore.rightsholderStore.currentRightsholderId,
            pagination,
            TargetSearchPublishersStore.toLegacyPublisherSearch(query)
        )
        const publishers = results.data
        return {
            parties: publishers.content.map((publisher) => TargetSearchPublishersStore.opToPartyDetails(publisher)),
            count: publishers.totalElements,
        }
    }

    static toLegacyPublisherSearch = (p: PublisherSearch): LegacyPublisherSearch => ({
        publisherName: p.fullName,
        publisherIpi: p.ipiNameNumber ?? null,
        publisherNumber: p.hfaNumber,
    })

    static opToPartyDetails = (pubWithWorkCount: PublisherModelWithWorksCount): SearchResultPartyDetails => ({
        ipId: pubWithWorkCount.ipId?.toString(),
        ipiNumber: pubWithWorkCount.ipiNumber,
        worksCount: pubWithWorkCount.totalWorks,
        name: pubWithWorkCount.publisherName,
        hfaPublisherNumber: pubWithWorkCount.hfaPublisherNumber,
    })
}

export default TargetSearchPublishersStore
